import { render } from "./SingleOption.vue?vue&type=template&id=14ea1267&scoped=true"
import script from "./SingleOption.vue?vue&type=script&lang=js"
export * from "./SingleOption.vue?vue&type=script&lang=js"

import "./SingleOption.vue?vue&type=style&index=0&id=14ea1267&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/Taitaen Swegon Prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14ea1267"]])

export default __exports__